// faq-filter.js

document.addEventListener('DOMContentLoaded', function () {
    // --- grab elements ---
    var filterButtons = document.querySelectorAll('.faq-filters-btn');
    var container = document.querySelector('.accordion-group.section-padding');
    if (!container) return;
    var allAccordions = container.querySelectorAll('.accordion');
    var viewMoreBtn = container.querySelector('.view-moreBtn');
    var viewLessBtn = container.querySelector('.view-lessBtn');

    // --- state ---
    var activeFilter = null;   // which filter is selected, or null
    var isViewMoreActive = false;  // false = show only first 3; true = show all

    if (filterButtons.length > 0) {
        var firstBtn = filterButtons[0];
        activeFilter = firstBtn.getAttribute('data-value').trim().toLowerCase();
        firstBtn.classList.add('active');
    }

    // --- wire up filter tabs ---
    for (var i = 0; i < filterButtons.length; i++) {
        (function (btn) {
            btn.addEventListener('click', function () {
                var val = btn.getAttribute('data-value').trim().toLowerCase();

                // toggle filter on/off
                if (activeFilter === val) {
                    activeFilter = null;
                } else {
                    activeFilter = val;
                }

                // reset view-more/less on filter change
                isViewMoreActive = false;

                // update button styling
                for (var j = 0; j < filterButtons.length; j++) {
                    filterButtons[j].classList.remove('active');
                }
                if (activeFilter) {
                    btn.classList.add('active');
                }

                render();
            });
        })(filterButtons[i]);
    }

    // --- wire up view-more / view-less ---
    if (viewMoreBtn) {
        viewMoreBtn.addEventListener('click', function () {
            isViewMoreActive = true;
            render();
        });
    }
    if (viewLessBtn) {
        viewLessBtn.addEventListener('click', function () {
            isViewMoreActive = false;
            render();
        });
    }

    // --- single render() to update everything ---
    function render() {
        // 1) build filtered list
        var filtered = [];
        for (var i = 0; i < allAccordions.length; i++) {
            var acc = allAccordions[i];
            var tagEl = acc.querySelector('.filter_by_tag');
            var tag = tagEl
                ? tagEl.textContent.trim().toLowerCase()
                : null;
            if (!activeFilter || (tag && tag === activeFilter)) {
                filtered.push(acc);
            }
        }

        // 2) decide how many to show
        var toShow = [];
        if (isViewMoreActive || filtered.length <= 3) {
            toShow = filtered;
        } else {
            for (var k = 0; k < 3; k++) {
                toShow.push(filtered[k]);
            }
        }

        // 3) update counter for visible accordions only
        for (var i = 0; i < toShow.length; i++) {
            var counterSpan = toShow[i].querySelector('.faq-counter');
            if (counterSpan) {
                counterSpan.textContent = (i + 1) + '.';
            }
        }

        // 4) apply to DOM, overriding any CSS !important
        for (var i = 0; i < allAccordions.length; i++) {
            var acc = allAccordions[i];
            if (toShow.indexOf(acc) !== -1) {
                acc.style.setProperty('display', 'block', 'important');
            } else {
                acc.style.setProperty('display', 'none', 'important');
            }
        }

        // 5) toggle the view-more / view-less buttons
        var needsToggle = filtered.length > 3;
        if (viewMoreBtn && viewLessBtn) {
            viewMoreBtn.style.display = (needsToggle && !isViewMoreActive) ? 'flex' : 'none';
            viewLessBtn.style.display = (needsToggle && isViewMoreActive) ? 'flex' : 'none';
        }

        const isMobile = window.innerWidth <= 767;

        if (!isMobile){
            if (viewMoreBtn) viewMoreBtn.style.display = "none";
            if (viewLessBtn) viewLessBtn.style.display = "none";
            viewMoreBtn.click();
        }
    }

    // --- initial paint ---
    render();
});
